import { Injectable } from "@angular/core";
import { PagedCrudService } from "@features/grid";
import { ISystemRole } from "./system-role";
import { HttpClient } from "@angular/common/http";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";

@Injectable({
    providedIn: "root"
})
export class SystemRoleService extends PagedCrudService<ISystemRole> {
    readonly url = "api/system-role";
    readonly entityTitle = "User Type";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    isDeletable(systemRoleId: string): Promise<boolean> {
        return this.handleRequest<boolean>(
            this.http.get<boolean>(`${this.url}/${systemRoleId}/is-deletable`),
            this.handlersFactory.getDefault()
        );
    }

    getDefaultPermissions(): Promise<ISystemRole[]> {
        return this.handleRequest<ISystemRole[]>(
            this.http.get<ISystemRole[]>(`${this.url}/default-permissions`),
            this.handlersFactory.getDefault()
        );
    }

    getAll(): Promise<ISystemRole[]> {
        return this.handleRequest<ISystemRole[]>(
            this.http.get<ISystemRole[]>(`${this.url}/all`),
            this.handlersFactory.getDefault()
        );
    }
}